import { FC, ReactNode } from "react"

type VerificationTextProps = {
  title: string
  children: ReactNode
}

export const VerificationText: FC<VerificationTextProps> = ({ title, children }) => {
  return (
    <div className="additional-names text-center">
      <h3 className="h3 additional-names__title">{title}</h3>
      <p className="additional-names__descr">{children}</p>
    </div>
  )
}
